export default __webpack_public_path__ + "static/media/meal.a1b6c6dc.mp4";